import { Category } from '@/payload-types'
import Link from 'next/link'
import { Fragment } from 'react'

interface Props {
    crumbs: Category['breadcrumbs']
}

export function Breadcrumbs({ crumbs }: Props) {
    return (
        <div className='text-accent uppercase font-bold mb-2 text-sm font-sans'>
            {crumbs?.map((crumb, index) => (
                <Fragment key={`breadcrumb-${crumb.id}-${index}`}>
                    {index > 0 && (
                        <span key={`carret-${crumb.id}-${index}`} className='text-xl font-light'>
                            {' '}
                            »{' '}
                        </span>
                    )}
                    <Link
                        data-ga={`[[&quot;Front page click&quot;,&quot;stream section click - 0&quot;,&quot;${crumb.url}&quot;,{&quot;metric19&quot;:1}]]`}
                        href={crumb.url || ''}
                    >
                        {crumb.label}
                    </Link>
                </Fragment>
            ))}
        </div>
    )
}
